// extracted by mini-css-extract-plugin
export default {"root":"StudentDiscountMessageBlock_root__eAMNB"};